import { IonAvatar, IonButton, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonNote, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { chevronForward, keyOutline } from "ionicons/icons";
import authStore from "../../store/auth";
import * as dateFns from 'date-fns';
import { id } from 'date-fns/locale';

// Helper function to safely format dates
const formatDate = (dateValue: string | null | undefined): string => {
    if (!dateValue) return '-';
    
    const date = new Date(dateValue);
    if (isNaN(date.getTime())) return '-';
    
    return dateFns.format(date, 'dd/MM/yyyy', { locale: id });
};

const Profile: React.FC = observer(() => {
    const history = useHistory();

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar color="primary">
                    <IonTitle>Profil</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar color="primary">
                        <IonTitle size="large">Profil</IonTitle>
                    </IonToolbar>
                </IonHeader>

                <div style={{ backgroundColor: '#3880FF' }}>
                    <div style={{ padding: '20px 10px' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
                            <IonAvatar>
                                <img alt="Silhouette of a person's head" src="https://ionicframework.com/docs/img/demos/avatar.svg" />
                            </IonAvatar>
                        </div>
                        <h5 style={{ color: 'white', textAlign: 'center', fontWeight: 500, margin: '0px 0px 5px 0px' }}>{authStore.auth_data?.user?.fullname}</h5>
                    </div>
                </div>

                <div style={{ margin: '20px 0' }}>
                    <IonList>
                        <IonItem button onClick={() => history.push('/change-password')}>
                            <IonIcon icon={keyOutline} slot="start" color="primary" />
                            <IonLabel>
                                <h3 style={{ fontSize: 16 }}>Ganti Password</h3>
                                <p style={{ fontSize: 14 }}>Ubah password akun Anda</p>
                            </IonLabel>
                            <IonIcon icon={chevronForward} slot="end" />
                        </IonItem>
                    </IonList>
                </div>

                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <IonButton color='danger' onClick={() => authStore.logout()}>Keluar</IonButton>
                </div>
            </IonContent>
        </IonPage>
    )
})

export default Profile;